(function () {
    var SELECTOR = '.tl__cart-goal__reward-description__drawer';
    // Bắt các dạng: 121,10PEN | 121,10 PEN | 1.210,10PEN
    var RE = /(\d[\d.]*(?:,\d{1,2})?)\s*PEN\b/g;

    function formatAmount(raw) {
      var num = parseFloat(raw.replace(/\./g, '').replace(',', '.'));
      if (isNaN(num)) return null;
      return 'S/. ' + num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function fixElement(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var oldText = node.nodeValue;
        if (oldText.indexOf('PEN') === -1) continue;
        var newText = oldText.replace(RE, function (match, amount) {
          return formatAmount(amount) || match;
        });
        if (newText !== oldText) node.nodeValue = newText;
      }
    }

    function run() {
      var els = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < els.length; i++) fixElement(els[i]);
    }

    // App render lại text mỗi khi giỏ hàng thay đổi, nên theo dõi DOM để format lại
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    }

    function init() {
      run();
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();